import { render, staticRenderFns } from "./Comparatif.vue?vue&type=template&id=5fb87793&scoped=true&"
import script from "./Comparatif.vue?vue&type=script&lang=js&"
export * from "./Comparatif.vue?vue&type=script&lang=js&"
import style0 from "./Comparatif.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Comparatif.vue?vue&type=style&index=1&id=5fb87793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb87793",
  null
  
)

export default component.exports